import { Injectable, inject } from '@angular/core';

import { AppConfig } from '@app/app.config';

@Injectable({
    providedIn: 'root',
})
export class ScriptProviderService {
    private readonly appConfig = inject(AppConfig);

    addLinkedInScript(): void {
        const linkedinPublicKey = this.appConfig.settings?.settings?.linkedin_id as string;

        if (!linkedinPublicKey) {
            console.warn('linkedIn public key is not set');
            return;
        }

        // Create a new script element for the LinkedIn code
        const script = document.createElement('script');
        script.type = 'text/javascript';

        // Copy the original code exactly as provided
        script.textContent = `
            _linkedin_partner_id = "${linkedinPublicKey}";
            window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
            window._linkedin_data_partner_ids.push(_linkedin_partner_id);
  `;
        document.head.appendChild(script);

        // Create second script element for the function
        const scriptFunction = document.createElement('script');
        scriptFunction.type = 'text/javascript';
        scriptFunction.textContent = `
            (function(l) {
              if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
              window.lintrk.q=[]}
              var s = document.getElementsByTagName("script")[0];
              var b = document.createElement("script");
              b.type = "text/javascript";b.async = true;
              b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
              s.parentNode.insertBefore(b, s);
            })(window.lintrk);
  `;
        document.head.appendChild(scriptFunction);

        // Create the noscript element with an image for tracking
        const noscript = document.createElement('noscript');
        const img = document.createElement('img');
        img.height = 1;
        img.width = 1;
        img.style.display = 'none';
        img.alt = '';
        img.src = 'https://px.ads.linkedin.com/collect/?pid=5765330&fmt=gif';
        noscript.appendChild(img);
        document.body.appendChild(noscript);
    }

    addBingAdsScript(): void {
        const bingAdsPublicKey = this.appConfig.settings?.settings?.bing_ads_id as string;

        if (!bingAdsPublicKey) {
            console.warn('Bind Ads public key is not set');
            return;
        }

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.textContent = `
         (function (w, d, t, r, u) {
            var f, n, i;
            (w[u] = w[u] || []),
            (f = function () {
                var o = { ti: '${bingAdsPublicKey}', enableAutoSpaTracking: true };
                (o.q = w[u]), (w[u] = new UET(o)), w[u].push('pageLoad');
            }),
            (n = d.createElement(t)),
            (n.src = r),
            (n.async = 1),
            (n.onload = n.onreadystatechange =
                function () {
                    var s = this.readyState;
                    (s && s !== 'loaded' && s !== 'complete') || (f(), (n.onload = n.onreadystatechange = null));
                }),
            (i = d.getElementsByTagName(t)[0]),
            i.parentNode.insertBefore(n, i);
        })(window, document, 'script', '//bat.bing.com/bat.js', 'uetq');
       `;
        document.head.appendChild(script);
    }

    addReb2bScript(): void {
        const idKey = this.appConfig.settings?.settings?.reb2b_id as string;

        if (!idKey) {
            console.warn('Reb2b analytics id not set');
            return;
        }

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.textContent = `
            !(function () {
                var reb2b = (window.reb2b = window.reb2b || []);
                if (reb2b.invoked) return;
                reb2b.invoked = true;
                reb2b.methods = ['identify', 'collect'];
                reb2b.factory = function (method) {
                    return function () {
                        var args = Array.prototype.slice.call(arguments);
                        args.unshift(method);
                        reb2b.push(args);
                        return reb2b;
                    };
                };
                for (var i = 0; i < reb2b.methods.length; i++) {
                    var key = reb2b.methods[i];
                    reb2b[key] = reb2b.factory(key);
                }
                reb2b.load = function (key) {
                    var script = document.createElement('script');
                    script.type = 'text/javascript';
                    script.async = true;
                    script.src = 'https://s3-us-west-2.amazonaws.com/b2bjsstore/b/' + key + '/${idKey}.js.gz';
                    var first = document.getElementsByTagName('script')[0];
                    first.parentNode.insertBefore(script, first);
                };
                reb2b.SNIPPET_VERSION = '1.0.1';
                reb2b.load('${idKey}');
            })();
       `;
        document.head.appendChild(script);
    }
}
